import { css } from "lit-element";
import { CircularProgress } from "@material/mwc-circular-progress";

export class KerikaLoader extends CircularProgress {
  static get styles() {
    return [
      super.styles,
      css`
        /* Regular size */
        :host,
        .mdc-circular-progress {
          height: 28px !important;
          width: 28px !important;
        }

        /* Small size */
        :host([small]),
        :host([small]) .mdc-circular-progress {
          height: 20px !important;
          width: 20px !important;
        }

        /* Large size */
        :host([large]),
        :host([large]) .mdc-circular-progress {
          height: 36px !important;
          width: 36px !important;
        }
      `,
    ];
  }

  constructor() {
    super();
    this.indeterminate = true;
  }

  static get properties() {
    return {
      small: { type: Boolean, reflect: true },
      large: { type: Boolean, reflect: true },
    };
  }
}

customElements.define("kerika-loader", KerikaLoader);
